import { render, staticRenderFns } from "./UploadMaterialComponent.vue?vue&type=template&id=b420b64a&scoped=true&"
import script from "./UploadMaterialComponent.vue?vue&type=script&lang=js&"
export * from "./UploadMaterialComponent.vue?vue&type=script&lang=js&"
import style0 from "./UploadMaterialComponent.vue?vue&type=style&index=0&id=b420b64a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b420b64a",
  null
  
)

export default component.exports